import PropTypes from 'prop-types';
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Header from 'ui-component/KeywordTracking.svg';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router';

const KeywordTracking = ({ open, handleClose }) => {
  const navigate = useNavigate();
  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          handleClose();
        }}
        style={{ color: '000000' }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '640px!important'
          }
        }}
      >
        <DialogTitle id="alert-dialog-title" style={{ padding: '0', height: '117px' }}>
          <img src={Header} alt="Company Logo" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="h2" style={{ marginBottom: '30px', marginTop: '40px' }}>
              New Feature Release: Keyword Tracking is Here!
            </Typography>
            <p style={{ marginBottom: '20px' }}>
              <Typography variant="p">
                We’re excited to introduce Keyword Tracking to help you supercharge your Walmart selling strategy!
              </Typography>
            </p>
            <Typography variant="h3" style={{ marginBottom: '20px' }}>
              What’s New:
            </Typography>
            <p style={{ marginBottom: '20px' }}>
              <Typography variant="p">
                <b>Item & Keyword Tagging: </b>Easily tag and organize items with relevant keywords for better tracking.
              </Typography>
            </p>
            <p style={{ marginBottom: '20px' }}>
              <Typography variant="p">
                <b>Bulk Uploads: </b>Save time by uploading keywords in bulk, streamlining your workflow
              </Typography>
            </p>
            <p style={{ marginBottom: '20px' }}>
              <Typography variant="p">
                <b>Sponsored & Organic Rank Tracking: </b>Monitor both sponsored and organic rankings to optimize your listings
                and ads.
              </Typography>
            </p>
            <p style={{ marginBottom: '20px' }}>
              <Typography variant="p">Click below to start tracking your keywords and watch your performance soar!</Typography>
            </p>
          </DialogContentText>
          <DialogActions style={{ padding: '0', justifyContent: 'space-between', marginBottom: '8px' }}>
            <Button
              variant="contained"
              onClick={() => {
                navigate('keyword-tracking');
                handleClose();
              }}
              autoFocus
            >
              Begin Tracking
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
};
KeywordTracking.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired
};
export default KeywordTracking;
